var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"background"},[_c('vue-loading',{attrs:{"type":"spin","color":"#fffff","size":{ width: '50px', height: '50px' }}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }